export enum ValueTypes {
  String,
  Decimal,
  Boolean,
  Integer,
  Date,
  Currency
}
